// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  axisEnd: "ResultPortrait__axisEnd",
  axisStart: "ResultPortrait__axisStart",
  barRule: "ResultPortrait__barRule",
  barSvg: "ResultPortrait__barSvg",
  big: "ResultPortrait__big",
  cap: "ResultPortrait__cap",
  capFaint: "ResultPortrait__capFaint",
  captionSpacer: "ResultPortrait__captionSpacer",
  chart: "ResultPortrait__chart",
  cutNote: "ResultPortrait__cutNote",
  delta: "ResultPortrait__delta",
  deltaIcon: "ResultPortrait__deltaIcon",
  explore: "ResultPortrait__explore",
  eyebrow: "ResultPortrait__eyebrow",
  facts: "ResultPortrait__facts",
  forecast3: "ResultPortrait__forecast3",
  forecastAlone: "ResultPortrait__forecastAlone",
  forecastBody: "ResultPortrait__forecastBody",
  gdpFigure: "ResultPortrait__gdpFigure",
  gdpFigureRight: "ResultPortrait__gdpFigureRight",
  head: "ResultPortrait__head",
  leadCap: "ResultPortrait__leadCap",
  pager: "ResultPortrait__pager",
  pagerBtn: "ResultPortrait__pagerBtn",
  pagerOn: "ResultPortrait__pagerOn",
  portrait3: "ResultPortrait__portrait3",
  priceBase: "ResultPortrait__priceBase",
  question: "ResultPortrait__question",
  ruleBox: "ResultPortrait__ruleBox",
  scenarioUnderline: "ResultPortrait__scenarioUnderline",
  scenarioWord: "ResultPortrait__scenarioWord",
  shareBody: "ResultPortrait__shareBody",
  shareStat: "ResultPortrait__shareStat",
  shareStatEnd: "ResultPortrait__shareStatEnd",
  sheetPanel: "ResultPortrait__sheetPanel",
  sheetPanelHosted: "ResultPortrait__sheetPanelHosted",
  sub: "ResultPortrait__sub",
  svg: "ResultPortrait__svg",
  tile: "ResultPortrait__tile",
  tileFoot: "ResultPortrait__tileFoot",
  tileHead: "ResultPortrait__tileHead",
  tileStat: "ResultPortrait__tileStat",
  tileTitle: "ResultPortrait__tileTitle",
  tiles: "ResultPortrait__tiles",
  todayTick: "ResultPortrait__todayTick",
  unempAside: "ResultPortrait__unempAside",
  unempFull: "ResultPortrait__unempFull",
  unempKey: "ResultPortrait__unempKey",
  unempOverlay: "ResultPortrait__unempOverlay",
  unempRow: "ResultPortrait__unempRow",
  unempWaffle: "ResultPortrait__unempWaffle",
  verdict: "ResultPortrait__verdict",
  waffleBox: "ResultPortrait__waffleBox",
  waffleSvg: "ResultPortrait__waffleSvg",
  wageRow: "ResultPortrait__wageRow",
  wageRows: "ResultPortrait__wageRows",
  wageTrack: "ResultPortrait__wageTrack",
  wageVal: "ResultPortrait__wageVal",
};
